import {
  DemographicOverQuota,
  DemographicTerminate
} from '../components/demographics';

import {
  DemographicRater as EngParentRater,
  DemographicRatee as EngParentRatee,
  DemographicAdditionalQuestions as EngParentAdditionalQuestions
} from '../components/demographics/EnglishParent'

import {
  DemographicRater as EngTeacherRater,
  DemographicRatee as EngTeacherRatee,
  DemographicAdditionalQuestions as EngTeacherAdditionalQuestions
} from '../components/demographics/EnglishTeacher'

import {
  DemographicRatee as EngSelfRatee,
  DemographicAdditionalQuestions as EngSelfAdditionalQuestions
} from '../components/demographics/EnglishSelf'

import {
  DemographicRater as SpanParentRater,
  DemographicRatee as SpanParentRatee,
  DemographicAdditionalQuestions as SpanParentAdditionalQuestions
} from '../components/demographics/SpanishParent'

import {
  DemographicRatee as SpanSelfRatee,
  DemographicAdditionalQuestions as SpanSelfAdditionalQuestions
} from '../components/demographics/SpanishSelf'

import {
  DemographicRater as FrnParentRater,
  DemographicRatee as FrnParentRatee,
  DemographicAdditionalQuestions as FrnParentAdditionalQuestions
} from '../components/demographics/FrenchParent'

import {
  DemographicRater as FrnTeacherRater,
  DemographicRatee as FrnTeacherRatee,
  DemographicAdditionalQuestions as FrnTeacherAdditionalQuestions
} from '../components/demographics/FrenchTeacher'

import {
  DemographicRatee as FrnSelfRatee,
  DemographicAdditionalQuestions as FrnSelfAdditionalQuestions
} from '../components/demographics/FrenchSelf'

const EnglishParentDemographicRoutes = [
  {
    path: '/Demographic/Rater',
    component: EngParentRater,
    monitorProgress: false
  },
  {
    path: '/Demographic/Ratee',
    component: EngParentRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: EngParentAdditionalQuestions,
    monitorProgress: false
  }
];

const EnglishTeacherDemographicRoutes = [
  {
    path: '/Demographic/Rater',
    component: EngTeacherRater,
    monitorProgress: false
  },
  {
    path: '/Demographic/Ratee',
    component: EngTeacherRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: EngTeacherAdditionalQuestions,
    monitorProgress: false
  }
];

const EnglishSelfDemographicRoutes = [
  {
    path: '/Demographic/Ratee',
    component: EngSelfRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: EngSelfAdditionalQuestions,
    monitorProgress: false
  }
];

const SpanishParentDemographicRoutes = [
  {
    path: '/Demographic/Rater',
    component: SpanParentRater,
    monitorProgress: false
  },
  {
    path: '/Demographic/Ratee',
    component: SpanParentRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: SpanParentAdditionalQuestions,
    monitorProgress: false
  }
];

const SpanishSelfDemographicRoutes = [
  {
    path: '/Demographic/Ratee',
    component: SpanSelfRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: SpanSelfAdditionalQuestions,
    monitorProgress: false
  }
];

const FrenchParentDemographicRoutes = [
  {
    path: '/Demographic/Rater',
    component: FrnParentRater,
    monitorProgress: false
  },
  {
    path: '/Demographic/Ratee',
    component: FrnParentRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: FrnParentAdditionalQuestions,
    monitorProgress: false
  }
];

const FrenchTeacherDemographicRoutes = [
  {
    path: '/Demographic/Rater',
    component: FrnTeacherRater,
    monitorProgress: false
  },
  {
    path: '/Demographic/Ratee',
    component: FrnTeacherRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: FrnTeacherAdditionalQuestions,
    monitorProgress: false
  }
];

const FrenchSelfDemographicRoutes = [
  {
    path: '/Demographic/Ratee',
    component: FrnSelfRatee,
    monitorProgress: false
  },
  {
    path: '/Demographic/AdditionalQuestions/:index',
    component: FrnSelfAdditionalQuestions,
    monitorProgress: false
  }
];

const GlobalDemographicRoutes = [{
    path: '/Demographic/Terminate',
    component: DemographicTerminate,
    monitorProgress: false
  },
  {
    path: '/Demographic/OverQuota',
    component: DemographicOverQuota,
    monitorProgress: false
  }
]

export const getDemographicRoutes = (versionId) => {
  switch (parseInt(versionId)) {
    case 36:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
      return [...EnglishParentDemographicRoutes, ...GlobalDemographicRoutes];
    case 37:
    case 56:
    case 57:
    case 58:
    case 59:
    case 60:
      return [...EnglishTeacherDemographicRoutes, ...GlobalDemographicRoutes];
    case 38:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
      return [...EnglishSelfDemographicRoutes, ...GlobalDemographicRoutes];
    case 44:
    case 45:
    case 46:
    case 47:
    case 48:
    case 49:
      return [...FrenchParentDemographicRoutes, ...GlobalDemographicRoutes];
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
      return [...SpanishParentDemographicRoutes, ...GlobalDemographicRoutes];
    case 61:
    case 62:
    case 63:
    case 64:
    case 65:
    case 66:
      return [...FrenchTeacherDemographicRoutes, ...GlobalDemographicRoutes];
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
      return [...FrenchSelfDemographicRoutes, ...GlobalDemographicRoutes];
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
      return [...SpanishSelfDemographicRoutes, ...GlobalDemographicRoutes];
    default:
      return null;
  }
}

export const getRaterDemographicRoutes = (versionId) => {
  var routes = getDemographicRoutes(versionId);

  return routes.filter(route => route.path.includes('Rater'));
}

export const getRateeDemographicRoutes = (versionId) => {
  var routes = getDemographicRoutes(versionId);

  return routes.filter(route => route.path.includes('Ratee'));
}